/**
 * Return a string of the current page's query params
 *
 * @returns {string} Returns - A string of the current page's query params
 */
export function getQueryParams() {
    return window.location.search.substring(1);
}

/**
 * Return an array of query param objects
 *
 * @returns {Array} Returns - An array of all the query param objects
 */
export function splitQueryParams() {
    const queryParams = getQueryParams();
    return queryParams.split('&');
}



// WEBPACK FOOTER //
// ./src/js/utils/query-param-helpers.js